var map = {
	"./en": "5939",
	"./en.js": "5939",
	"./flag_en.jpg": "a706",
	"./flag_id.jpg": "c0d3",
	"./flag_id.png": "9721",
	"./id": "4cf9",
	"./id.js": "4cf9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4d7d";